module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "flex three"
  }, [_c('codemirror', {
    staticClass: "code-container",
    attrs: {
      "code": _vm.compiledComponent,
      "options": _vm.editorOption
    }
  }), _c('div', {
    staticClass: "container two-third"
  }, [_c('div', [_c('div', [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newComponent.name),
      expression: "newComponent.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.newComponent.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newComponent.name = $event.target.value
      }
    }
  })]), _c('hr'), _c('div', {
    staticClass: "flex one"
  }, [_c('div', [_c('label', {
    staticClass: "label-header"
  }, [_vm._v("Template")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newComponent.selectedTemplate),
      expression: "newComponent.selectedTemplate"
    }],
    on: {
      "change": function($event) {
        _vm.newComponent.selectedTemplate = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.options.template), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(option))])
  }))])]), _c('div', {
    staticClass: "flex two"
  }, [_c('div', [_c('label', {
    staticClass: "label-header"
  }, [_vm._v("Style")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newComponent.selectedStyle),
      expression: "newComponent.selectedStyle"
    }],
    on: {
      "change": function($event) {
        _vm.newComponent.selectedStyle = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.options.styles), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(option))])
  }))]), _c('div', [_c('label', {
    staticClass: "label-header"
  }, [_vm._v("Scoped Style"), _c('br'), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newComponent.selectedScoped),
      expression: "newComponent.selectedScoped"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newComponent.selectedScoped) ? _vm._i(_vm.newComponent.selectedScoped, null) > -1 : (_vm.newComponent.selectedScoped)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newComponent.selectedScoped,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.newComponent.selectedScoped = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.newComponent.selectedScoped = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.newComponent.selectedScoped = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "checkable"
  }, [_vm._v("on")])])])])]), _c('hr'), _c('div', {
    staticClass: "component-form"
  }, [_c('div', {
    staticClass: "flex two"
  }, [_c('div', [_vm._m(2), _c('button', {
    on: {
      "click": _vm.addNewProp
    }
  }, [_vm._v("Add")]), _vm._l((_vm.newComponent.props), function(prop, index) {
    return _c('div', [_c('div', {
      staticClass: "flex",
      class: {
        'two': prop.validation
      }
    }, [_c('label', {
      staticClass: "label-header"
    }, [_vm._v("Name"), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (prop.name),
        expression: "prop.name"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": _vm._s(prop.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          prop.name = $event.target.value
        }
      }
    })]), (prop.validation) ? _c('label', {
      staticClass: "label-header"
    }, [_vm._v("Type"), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (prop.type),
        expression: "prop.type"
      }],
      on: {
        "change": function($event) {
          prop.type = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0]
        }
      }
    }, _vm._l((_vm.options.propsType), function(option) {
      return _c('option', {
        domProps: {
          "value": option
        }
      }, [_vm._v(_vm._s(option))])
    }))]) : _vm._e()]), _c('div', {
      staticClass: "flex two"
    }, [_c('label', {
      staticClass: "label-header"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (prop.validation),
        expression: "prop.validation"
      }],
      attrs: {
        "type": "checkbox",
        "value": "prop.validation"
      },
      domProps: {
        "value": "prop.validation",
        "checked": Array.isArray(prop.validation) ? _vm._i(prop.validation, "prop.validation") > -1 : (prop.validation)
      },
      on: {
        "change": function($event) {
          var $$a = prop.validation,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "prop.validation",
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (prop.validation = $$a.concat($$v))
            } else {
              $$i > -1 && (prop.validation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            prop.validation = $$c
          }
        }
      }
    }), _c('span', {
      staticClass: "checkable"
    }, [_vm._v("Validation")])]), (prop.validation) ? _c('label', {
      staticClass: "label-header"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (prop.required),
        expression: "prop.required"
      }],
      attrs: {
        "type": "checkbox",
        "value": "prop.required"
      },
      domProps: {
        "value": "prop.required",
        "checked": Array.isArray(prop.required) ? _vm._i(prop.required, "prop.required") > -1 : (prop.required)
      },
      on: {
        "change": function($event) {
          var $$a = prop.required,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "prop.required",
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (prop.required = $$a.concat($$v))
            } else {
              $$i > -1 && (prop.required = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            prop.required = $$c
          }
        }
      }
    }), _c('span', {
      staticClass: "checkable"
    }, [_vm._v("Required")])]) : _vm._e()]), _c('div', {
      staticClass: "remove-button-wrapper"
    }, [_c('button', {
      staticClass: "error button",
      on: {
        "click": function($event) {
          _vm.removeProp(index)
        }
      }
    }, [_vm._v("Remove")])])])
  })], 2), _c('div', [_vm._m(3), _c('button', {
    on: {
      "click": _vm.addNewData
    }
  }, [_vm._v("Add")]), _vm._l((_vm.newComponent.data), function(data, index) {
    return _c('div', [_c('label', {
      staticClass: "label-header"
    }, [_vm._v("Name"), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.name),
        expression: "data.name"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": _vm._s(data.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          data.name = $event.target.value
        }
      }
    })]), _c('div', {
      staticClass: "remove-button-wrapper"
    }, [_c('button', {
      staticClass: "error button",
      on: {
        "click": function($event) {
          _vm.removeData(index)
        }
      }
    }, [_vm._v("Remove")])])])
  })], 2)]), _c('hr'), _c('div', {
    staticClass: "flex two"
  }, [_c('div', [_vm._m(4), _c('button', {
    on: {
      "click": _vm.addNewComputed
    }
  }, [_vm._v("Add")]), _vm._l((_vm.newComponent.computed), function(computed, index) {
    return _c('div', [_c('label', {
      staticClass: "label-header"
    }, [_vm._v("Name"), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (computed.name),
        expression: "computed.name"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": _vm._s(computed.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          computed.name = $event.target.value
        }
      }
    })]), _c('div', {
      staticClass: "remove-button-wrapper"
    }, [_c('button', {
      staticClass: "error button",
      on: {
        "click": function($event) {
          _vm.removeComputed(index)
        }
      }
    }, [_vm._v("Remove")])])])
  })], 2), _c('div', [_vm._m(5), _c('button', {
    on: {
      "click": _vm.addNewWatch
    }
  }, [_vm._v("Add")]), _vm._l((_vm.newComponent.watches), function(watch, index) {
    return _c('div', [_c('label', {
      staticClass: "label-header"
    }, [_vm._v("Name"), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (watch.name),
        expression: "watch.name"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": _vm._s(watch.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          watch.name = $event.target.value
        }
      }
    })]), _c('div', {
      staticClass: "remove-button-wrapper"
    }, [_c('button', {
      staticClass: "error button",
      on: {
        "click": function($event) {
          _vm.removeWatch(index)
        }
      }
    }, [_vm._v("Remove")])])])
  })], 2)]), _c('hr'), _c('div', {
    staticClass: "flex two"
  }, [_c('div', [_vm._m(6), _c('button', {
    on: {
      "click": _vm.addNewMethod
    }
  }, [_vm._v("Add")]), _vm._l((_vm.newComponent.methods), function(method, index) {
    return _c('div', [_c('label', {
      staticClass: "label-header"
    }, [_vm._v("Name"), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (method.name),
        expression: "method.name"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": _vm._s(method.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          method.name = $event.target.value
        }
      }
    })]), _c('div', {
      staticClass: "remove-button-wrapper"
    }, [_c('button', {
      staticClass: "error button",
      on: {
        "click": function($event) {
          _vm.removeMethod(index)
        }
      }
    }, [_vm._v("Remove")])])])
  })], 2), _c('div', [_vm._m(7), _c('div', {
    staticClass: "flex two"
  }, _vm._l((_vm.options.lifecycles), function(option) {
    return _c('div', [_c('label', {
      staticClass: "label-header"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newComponent.lifecycleHooks),
        expression: "newComponent.lifecycleHooks"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": option,
        "checked": Array.isArray(_vm.newComponent.lifecycleHooks) ? _vm._i(_vm.newComponent.lifecycleHooks, option) > -1 : (_vm.newComponent.lifecycleHooks)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.newComponent.lifecycleHooks,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.newComponent.lifecycleHooks = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.newComponent.lifecycleHooks = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.newComponent.lifecycleHooks = $$c
          }
        }
      }
    }), _c('span', {
      staticClass: "checkable mini"
    }, [_vm._v(_vm._s(option.name))])])])
  }))])])])]), _c('div', {
    staticClass: "introduce"
  }, [_c('div', {
    staticClass: "introduction",
    class: {
      'intro-active': _vm.showIntro
    }
  }, [_c('h2', {
    on: {
      "click": function($event) {
        _vm.showIntro = !_vm.showIntro
      }
    }
  }, [_vm._v("About vue-component-generator"), (_vm.showIntro) ? _c('span', {
    staticClass: "hide-intro"
  }, [_vm._v("Close")]) : _vm._e()]), (_vm.showIntro) ? _c('div', [_vm._v("Vue Component Generator was created for the purpose of describing the vue component. Please refer to the guide because some parts are not included."), _c('br'), _vm._v("이 프로젝트는 Vue 컴포넌트에 대한 설명을 위해 만들었습니다. 꼭 필요한 부분만 포함하였으므로 자세한 내용은 가이드를 참조하세요"), _c('br'), _vm._v("- ChangJoo Park"), _c('br'), _vm._m(8)]) : _vm._e()])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "header"
  }, [_c('a', {
    staticClass: "brand"
  }, [_vm._v("Vue Component Generator")]), _c('div', {
    staticClass: "menu"
  }, [_c('a', {
    staticClass: "button icon-puzzle",
    attrs: {
      "href": "https://github.com/ChangJoo-Park/vue-component-generator",
      "target": "_blank"
    }
  }, [_vm._v("Github Repo")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-header"
  }, [_vm._v("Component Name"), _c('small', [_vm._v("(camelCase -> kebab-case)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex two"
  }, [_c('h2', [_vm._v("Props"), _c('small', [_c('a', {
    attrs: {
      "href": "https://vuejs.org/v2/guide/components.html#Prop-Validation",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "guide",
    attrs: {
      "src": "https://vuejs.org/images/logo.png"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Data"), _c('small', [_c('a', {
    attrs: {
      "href": "https://vuejs.org/v2/api/#Options-Data",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "guide",
    attrs: {
      "src": "https://vuejs.org/images/logo.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Computed"), _c('small', [_c('a', {
    attrs: {
      "href": "https://vuejs.org/v2/guide/computed.html#Computed-Properties",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "guide",
    attrs: {
      "src": "https://vuejs.org/images/logo.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Watch"), _c('small', [_c('a', {
    attrs: {
      "href": "https://vuejs.org/v2/guide/computed.html#Watchers",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "guide",
    attrs: {
      "src": "https://vuejs.org/images/logo.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Method"), _c('small', [_c('a', {
    attrs: {
      "href": "https://vuejs.org/v2/api/#methods",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "guide",
    attrs: {
      "src": "https://vuejs.org/images/logo.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Lifecycle Hooks"), _c('small', [_c('a', {
    attrs: {
      "href": "https://vuejs.org/v2/guide/instance.html#Instance-Lifecycle-Hooks",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "guide",
    attrs: {
      "src": "https://vuejs.org/images/logo.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/pcjpcj2",
      "target": "_blank"
    }
  }, [_vm._v("twitter  ")])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/pcjpcj2",
      "target": "_blank"
    }
  }, [_vm._v("github  ")])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/vuejs-kr",
      "target": "_blank"
    }
  }, [_vm._v("vue.js Korean user organization")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-be227f0c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 322
// module chunks = 2